import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AgentApiAllianceSettingShow } from '@/types/serializers';
import { ALLIANCE_SETTING_QUERY_KEY } from './useFetchAllianceSetting';

export default function useDeleteAllianceLogo() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const response = await fetch('/agent/api/alliance_setting/destroy_logo', {
        method: 'DELETE',
        headers: {
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
      });

      if (!response.ok) {
        let errorMessage = 'ロゴの削除に失敗しました';
        try {
          const errorData: { error?: string; errors?: string[] } = await response.json();
          errorMessage = errorData.errors?.[0] || errorData.error || errorMessage;
        } catch {
          // JSONパースに失敗した場合はデフォルトメッセージを使用
        }
        throw new Error(errorMessage);
      }

      const data: AgentApiAllianceSettingShow = await response.json();
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ALLIANCE_SETTING_QUERY_KEY });
    },
  });
}
